(function() {
	'use strict';

	angular.module('widgets.buyer')
	.service('buyerStdCurrentShortagesService', buyerStdCurrentShortagesService);
	
	function buyerStdCurrentShortagesService($http, URLS, leanFilterService, $experiments) {
		return {
			getMyCurrentShortages: getMyCurrentShortages,
			getDrilldownFilters: getDrilldownFilters,
			isCurrentUserBuyerInSites: isCurrentUserBuyerInSites
		};

		function isCurrentUserBuyerInSites() {
			var url = addQueryParam(URLS.host + URLS.isUserValidBuyer,
				leanFilterService.getFactoryList(), {}, false);
			return $http.get(url).then(isCurrentUserBuyerInSitesComplete)
				.catch(disCurrentUserBuyerInSitesFailed);

			function isCurrentUserBuyerInSitesComplete(response) {
				if (response) {
					return response.data;
				}
				return false;
			}

			function disCurrentUserBuyerInSitesFailed(error) {
				return false;
			}
		}

		function getMyCurrentShortages(breakdown) {
			var queryParams = leanFilterService.getQueryParamsObject(true);
			if (breakdown) {
				queryParams['breakdown'] = breakdown;
			}
			var url = addQueryParam(URLS.host + URLS.myCurrentShortages,
				leanFilterService.getFactoryList(), queryParams, false);
			return $http.get(url);
		}

		function addSelectDrilldownFilter(filtersObj, field, value, comparatorKey, isReactTable) {
			if (isReactTable) {
				var comparator = _.find(leanFilterService.comparators, ['abbr', comparatorKey]).name;
				filtersObj[field] = {
					id: field,
					comparator: comparator,
					filterType: 'rangeFilter',
					valueOne: value
				};
			} else {
				filtersObj[field + 'ValueOne'] = value;
				filtersObj[field + 'Comparator'] = comparatorKey;
			}
		}

		function getDrilldownFilters(type, breakdown, reportExperimentFlag, isReactLeanTable) {
			var filtersObj = leanFilterService.getQueryParamsObject(true, true);
			var isReactTable = isReactLeanTable || (reportExperimentFlag && $experiments.isEnabled(reportExperimentFlag));
			if (!isReactTable) {
				filtersObj['drilldown'] = 1;
			}
			addSelectDrilldownFilter(filtersObj, 'daysInShortage', 1, 'gte', isReactTable);
			filtersObj['factory'] = leanFilterService.getFactoryList();
			if (!breakdown || breakdown !== 'criticalityLevel') {
				var onOrderFirmedKey = isReactTable ? 'firmedOnOrderQuantity' : 'onOrderFirmed';
				var onOrderPlannedKey = isReactTable ? 'plannedOnOrderQuantity' : 'onOrderPlanned';
				switch (type) {
				case 'firmed':
					addSelectDrilldownFilter(filtersObj, onOrderFirmedKey, 0, 'gt', isReactTable);
					break;
				case 'planned':
					addSelectDrilldownFilter(filtersObj, onOrderFirmedKey, 0, 'eq', isReactTable);
					addSelectDrilldownFilter(filtersObj, onOrderPlannedKey, 0, 'gt', isReactTable);
					break;
				case 'nosupply':
					addSelectDrilldownFilter(filtersObj, onOrderFirmedKey, 0, 'eq', isReactTable);
					addSelectDrilldownFilter(filtersObj, onOrderPlannedKey, 0, 'eq', isReactTable);
					break;
				}
			} else {
				filtersObj[isReactTable ? 'shortageCriticalityLevelId' : 'shortageCriticalityLevel'] = type;
			}
			return filtersObj;
		}
	}
})();